module.exports = __webpack_public_path__ + "static/media/img_17.cffd4d9e.png";